export function getDummyNewsItems() {
  return [
    {
      id: 1,
      // start_date: 'JANUARY 15',
      // end_date: 'APRIL 1',
      // start_year: '2022',
      // end_year: '2022',
      start_date: '2022-01-15',
      end_date: '2022-04-01',
      start_time: '15:00:00',
      end_time: '',
      // start_time: '3pm',
      // end_time: '',
      title: 'Goup exhibition “Botanical”, Las Laguna Gallery, Laguna Beach, CA',
      images: [
        {
          name: 'sss.png',
          url: 'https://freight.cargo.site/w/1500/q/75/i/7ddbfef124a8b4c613bff2a0892840d1c3a44a95a61b7c15d5a7ac1d573ec534/Chloe.jpg'
        },
        {
          name: 'xxx.png',
          url: 'https://freight.cargo.site/w/1500/q/75/i/1d5b2beb74d04b6836c6a2e3d88cc5c2cf95cc66868a34b10c62e6d3fd5d5013/Colin.jpg'
        }
      ],
      body:
        '<p>BASL: Bay Art Seekers Lounge” is a group exhibition dedicated to amplifying the diverse voices of the Bay Area’s creative community.</p>' +
        '<p style="margin-top: 24px;">3344 24th St</p>' +
        '<p>San Francisco, CA 94110</p>'
    },
    {
      id: 2,
      start_date: '',
      end_date: '2022-09-01',
      start_time: '12:00:00',
      end_time: '12:00:00',
      title: 'Uplift/ Heavy Lift',
      images: [
        {
          name: 'zzz.png',
          url: 'https://freight.cargo.site/w/2500/q/75/i/27ca96b3f3dfcd0cf54d0412c0a01b09fc111f8af448b14d753cf8120a35e713/Uplift-Heavy-Lift.jpg'
        }
      ],
      body:
        '<p>Curated by Thea Quiray Tagle</p>' +
        '<p>In this year’s juried show at the <a href="">Berkeley Art Center</a>, 39 artists reflect on the nuanced layers of rage, strength, grief, resilience, and perseverance that have marked our lives over the past 15 months. Collectively, works in the exhibition acknowledge the potential for art to provide an anchor in challenging times as we move from isolation back out into the world at large.</p>' +
        '<p>1275 Walnut Street<br/>' +
        'Berkley, CA 94709<br/>' +
        '510.644.6893<br/>' +
        '<p>Gallery hours: <br/> Wed-Sun, 11AM-5PM </p>'
    },
    {
      id: 3,
      start_date: '2022-02-01',
      end_date: '',
      start_time: '17:00:00',
      title: 'Goup exhibition “Botanical”, Las Laguna Gallery, Laguna Beach, CA',
      images: [],
      body: 'Gallery + Online Exhibition'
    }
  ]
}

export function getDefaultBio() {
  let str =
    '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Cras tincidunt lobortis feugiat vivamus at augue eget arcu dictum. In ornare quam viverra orci sagittis eu volutpat odio facilisis. Sed tempus urna et pharetra pharetra. Arcu risus quis varius quam quisque id.</p>'
  return str
}

export function getDefaultStory() {
  let str =
    '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Cras tincidunt lobortis feugiat vivamus at augue eget arcu dictum. In ornare quam viverra orci sagittis eu volutpat odio facilisis. Sed tempus urna et pharetra pharetra. Arcu risus quis varius quam quisque id.</p>'
  return str
}
